/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        name: "拷贝",
        type: "module-name"
    },
    {
        key: "property_data",
        name: "属性",
        type: "custom",
        content: [{
                key: "icon_url",
                name: "背景图",
                type: "img"
            },
            {
                key: "text",
                name: "拷贝内容",
                type: "text"
            },
            {
                key: "copySuccess",
                name: "复制成功文案",
                type: "text"
            },
            {
                key: "height",
                name: "点击范围高度",
                type: "text"
            },
            {
                key: "bottom",
                name: "点击范围底部",
                type: "text"
            }
        ]
    }
];
export default config;